var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-grid-index-loader animated fadeIn"},[_c('UIGradientLoader'),_vm._v(" "),_c('UIGradientLoader'),_vm._v(" "),_c('UIGradientLoader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }